import { useEffect, useRef, useState } from "react";
import { Box, Image, AspectRatio, Skeleton } from "@chakra-ui/react";
import { Airhelp } from "@airhelp/react";
import type { PostListImageProps } from "./PostListImage.d";

export const PostListImage = ({ src, alt }: PostListImageProps) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [isImageReady, setIsImageReady] = useState(false);

  useEffect(() => {
    if (!isImageReady && imageRef.current?.complete) {
      setIsImageReady(true);
    }
  }, [isImageReady]);

  return src ? (
    <Skeleton isLoaded={isImageReady} rounded="xl" startColor="greyscale.200" endColor="greyscale.400">
      <AspectRatio ratio={19 / 12} mb={4}>
        <Image ref={imageRef} src={src} onLoad={() => setIsImageReady(true)} objectFit="cover" rounded="xl" alt={alt} />
      </AspectRatio>
    </Skeleton>
  ) : (
    <AspectRatio ratio={19 / 12} mb={4}>
      <Box bgColor="primary.900" rounded="xl" sx={{ ".chakra-icon": { w: "42%", h: "22%" } }}>
        <Airhelp color="white" />
      </Box>
    </AspectRatio>
  );
};
